/**
 * Renders a list of collapsible sections for one report tab, plus an
 * "Expand all / Collapse all" control. By default the FIRST section is open
 * and the rest are collapsed, so a tab is scannable without being a bare wall
 * of headers. Owns open state; remount (via key) resets to defaults.
 */
import { useState } from "react";
import DisclosureCard from "./DisclosureCard";

export default function DisclosureGroup({ sections = [], idPrefix = "disc" }) {
  const [openKeys, setOpenKeys] = useState(
    () => new Set(sections.length ? [sections[0].key] : [])
  );

  if (!sections.length) return null;

  const toggle = (k) =>
    setOpenKeys((prev) => {
      const next = new Set(prev);
      next.has(k) ? next.delete(k) : next.add(k);
      return next;
    });
  const expandAll = () => setOpenKeys(new Set(sections.map((s) => s.key)));
  const collapseAll = () => setOpenKeys(new Set());
  const allOpen = openKeys.size === sections.length;

  return (
    <div className="space-y-3">
      <div className="flex justify-end">
        <button
          type="button"
          onClick={allOpen ? collapseAll : expandAll}
          data-testid={`${idPrefix}-toggle-all`}
          className="text-xs font-medium text-slate-500 hover:text-slate-800 transition-colors"
        >
          {allOpen ? "Collapse all" : "Expand all"}
        </button>
      </div>
      {sections.map((s) => (
        <DisclosureCard
          key={s.key}
          title={s.title}
          badge={s.badge}
          open={openKeys.has(s.key)}
          onToggle={() => toggle(s.key)}
          testid={`${idPrefix}-${s.key}`}
        >
          {s.body}
        </DisclosureCard>
      ))}
    </div>
  );
}
